import * as React from "react";
const SvgTaskType = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props}><path d="M5 12v2h11V9H5v2H3V7h9V2H0v5h2v5z" /></svg>;
export default SvgTaskType;